<template>
  <div>
    <template v-if="!state.editMode">
      <template v-if="!state.documentsToUpload.length > 0">
        <PickersWrapper class="mt-20" :openWindow="refInstall" />
      </template>
      <template v-else>
        <UploadViewer class="mt-10" :openWindow="refInstall" />
      </template>
    </template>
    <div v-show="state.editMode">
      <ImageEdit @install="install" />
    </div>
  </div>
</template>

<script>
import PickersWrapper from './PickersWrapper'
import UploadViewer from './UploadViewer'
import ImageEdit from './ImageEdit'
import { useWindowResize } from '@sichern/ui-elements'
import { state, mutations } from '@/components/FileUpload/Observables/fileUpload'

export default {
  props: {
    metadata: {
      type: Object,
      default: {}
    },
    documentsFromRequest: {
      type: Array,
      default: []
    }
  },
  components: {
    PickersWrapper,
    UploadViewer,
    ImageEdit
  },
  data() {
    return {
      windowResize: useWindowResize(this),
      refInstall: '',
      state
    }
  },
  created() {
    mutations.setMetadata(this.metadata)
    if (this.documentsFromRequest.length === 0) {
      mutations.cleanAllDocuments()
    }
  },
  methods: {
    install(value) {
      this.refInstall = value.install
    }
  },
}
</script>